<div *ngIf="edited" id="container" class="col-md-5" style="margin-left:17px;">
  Felmeddelande
  <button class="pull-right" id="x" (click)="closeErrorMsg()">x</button>
  <div *ngIf="edited">
    {{errormsg.msg.message | json}} <br><br>
  </div>
</div>